import {
  ComponentClass,
  ComponentProps,
  ComponentType,
  FunctionComponent,
} from 'react';
import { ConnectedComponent } from 'react-redux';
import { Dispatch } from 'redux';
import { getUniqueKey } from '../../utils/NumberUtils';

export const OPEN_MODAL_ACTION = 'OPEN_MODAL_ACTION';
export const CHANGE_PROPS_MODAL_ACTION = 'CHANGE_PROPS_MODAL_ACTION';
export const CLOSE_MODAL_ACTION = 'CLOSE_MODAL_ACTION';

export const openModal = <
  C extends
    | FunctionComponent<any>
    | ComponentType
    | ComponentClass
    | ConnectedComponent<ComponentType, any>
>(
  component: C,
  componentProps: ComponentProps<C> & { modalKey?: string | number },
  key?: string
) => {
  const payload = {
    component,
    componentProps,
    key: key ?? componentProps?.modalKey ?? getUniqueKey(),
    opened: true,
  };
  return {
    type: OPEN_MODAL_ACTION,
    payload,
  };
};

export const changeModalProps = (key: string, componentProps: any) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: CHANGE_PROPS_MODAL_ACTION,
      payload: {
        key,
        componentProps,
      },
    });
  };
};

export const closeModal = (key?: string) => {
  return (dispatch: Dispatch) => {
    dispatch({
      type: CLOSE_MODAL_ACTION,
      payload: key,
    });
  };
};
